module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "faq card-container"
  }, [_h('div', {
    staticClass: "card three-times"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["教えて パンダくん"])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('table', {
    staticClass: "table"
  }, [_h('tbody', [_h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q1"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "「整体」って、どんなときに行くの？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q1"
    }
  }), " ", _h('div', {
    staticClass: "column",
    attrs: {
      "id": "q1-answer"
    }
  }, [_h('div', {
    staticClass: "answer row"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  }), _h('span', ["こんなときにきてください"])]), " ", _h('div', {
    staticClass: "panda-flex"
  }, [_h('div', {
    staticClass: "segment"
  }, [_h('ul', [_h('li', ["★ あたま・かお"]), " ", _h('li', ["頭痛がする"]), " ", _h('li', ["耳鳴りがする"]), " ", _h('li', ["あごが痛む"]), " ", _h('li', ["顔の歪み"])]), " ", _h('ul', [_h('li', ["★ かた・くび"]), " ", _h('li', ["肩、首すじがこる"]), " ", _h('li', ["首が重い、だるい"]), " ", _h('li', ["首が回らない"])]), " ", _h('ul', [_h('li', ["★ 背中"]), " ", _h('li', ["背中がはる、痛む"]), " ", _h('li', ["猫背が気になる"]), " ", _h('li', ["肩の左右の高さが違う"])]), " ", _h('ul', [_h('li', ["★ うで・ひじ"]), " ", _h('li', ["腕が上がらない"]), " ", _h('li', ["肘や手首が痛む"]), " ", _h('li', ["指先がしびれる"]), " ", _h('li', ["四十肩・五十肩"])])]), " ", _h('img', {
    staticClass: "q1-image",
    attrs: {
      "src": "/images/panda-faq.png",
      "alt": "パンダくん"
    }
  }), " ", _h('div', {
    staticClass: "segment"
  }, [_h('ul', [_h('li', ["★ こし"]), " ", _h('li', ["慢性的に重い、痛い"]), " ", _h('li', ["腰が曲がる"]), " ", _h('li', ["重いものを持つのが不安だ"]), " ", _h('li', ["お尻から太ももの裏が痛む"]), " ", _h('li', ["骨盤ベルトをはずせない"])]), " ", _h('ul', [_h('li', ["★ ひざ"]), " ", _h('li', ["痛みで歩けない"]), " ", _h('li', ["正座ができない"]), " ", _h('li', ["階段の昇降時に痛む"]), " ", _h('li', ["O脚　X脚"])]), " ", _h('ul', [_h('li', ["★ あし"]), " ", _h('li', ["股関節の痛み"]), " ", _h('li', ["ふくらはぎがだるい"]), " ", _h('li', ["足がよくつる"]), " ", _h('li', ["足底が痛む"]), " ", _h('li', ["足の長さが違う"])]), " ", _h('ul', [_h('li', ["★ その他"]), " ", _h('li', ["冷え性"]), " ", _h('li', ["便秘 下痢 胃弱"]), " ", _h('li', ["眠りが浅い、不眠"]), " ", _h('li', ["月経不順　生理痛"]), " ", _h('li', ["更年期障害"])])])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q2"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "どういう人が整体に来ていますか？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q2"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q2-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["当院では、中学・高校生から80代の人まで、幅広い世代の方がお見えになります。"]), " ", _h('p', ["特に多いのは、男性では３０代後半から５０代の働き盛りで、仕事の疲労や長時間のデスクワーク、車の運転、職場のストレスなどから首から肩のコリ、腰の痛みでお見えになります。"]), " ", _h('p', ["女性では更に幅広く、３０代前半から６０代となっています。職場での疲労に加え、家事での疲れ、職場や家庭、地域での人間関係によるストレスも原因で体調を崩される方が多いようです。また、女性特有の更年期障害からくる症状の方もお見えになります。"]), " ", _h('p', ["中学・高校生では、部活動による肉体の疲労や痛み、成長痛の症状でも見えています。この世代で気になるのは、猫背など姿勢が悪く、それが肩こりや腰痛の原因になっていると思われる人が多いことです。"]), " ", _h('p', ["年配の方では、膝の関節痛も多くなりますが、健康を維持するためにという方も見えます。"]), " ", _h('p', ["また、アマチュア・ゴルファーや市民ランナーなど、体のメンテナンスのためという方も見えます。"])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q3"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "どれくらい通えば良くなりますか？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q3"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q3-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["その人の症状や体質、年齢や職業などによって異なるので、正確には言えません。"]), " ", _h('p', ["腰痛の場合、１回の施術でほとんど痛みがなくなり、楽に動けるようになったという方も見えますが、再発予防も含めて２〜３回程度通っていただいています。慢性的に腰痛という方は、定期的に通っていただく必要があります。"]), " ", _h('p', ["肩や首のコリは、職業や体質により、かなり個人差があります。２〜３回の施術である程度良くなると思われます。その後、また肩にコリを感じたら、その都度予約して来てもらっています。"]), " ", _h('p', ["膝の関節痛も、症状や年齢によりかなり個人差があります。初めは一週間おきに施術を行っていき、ある程度痛みが改善されたら、ご相談して施術の間隔を空けて様子を見ていきます。"]), " ", _h('p', ["繰り返しになりますが、人によりかなりの個人差がありますので、ご相談しながら施術してまいります。"])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q4"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "「整体」って、痛くないですか？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q4"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q4-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["整体というと、「骨をボキボキ鳴らして何だか怖そう」とか、「ツボを押されて痛そうだな」というイメージをお持ちの方が少なからずおられます。テレビで、「足ツボ」などを罰ゲームのように扱われ、その影響もあると思われますが、それは間違った認識です。"]), " ", _h('p', ["当院では、その人の症状や体質、年齢など十分考慮し、本人に確認しながら適切な力加減で筋肉や靭帯をゆるめ、ツボを刺激していきます。"]), " ", _h('p', ["「これくらいが痛くて気持ちがいい（イタギモ）」と思える力加減は人によって違います。痛みが強いと体に余分な力が入り、かえって筋肉を強ばらせることになります。"])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q5"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "「中国整体」と他の整体とどう違うの？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q5"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q5-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["一口に整体といっても様々な手法があり、また、「中国整体」という看板を掲げている整体院でも、理念などにより施術内容に違いがあります。"]), " ", _h('p', ["当院の「中国整体術」は、１００％手技で行うことで、その人の体の状態を十分把握し、硬くなった筋肉や靭帯をやわらげた後、骨格矯正により本来の正しい姿勢に戻します。"]), " ", _h('p', ["「中国整体術」は、人が本来持っている〈自然治癒力〉を高め、体と心の〈根本治癒〉を目指した整体術です。"])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q6"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "なんで、「中国整体術」っていうの？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q6"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q6-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["中国では二千年以上も前から東洋医学・漢方医学の研究が行われてきました。日本には奈良時代ごろ、漢方医学が伝わりました。「中国整体術」とは、現在も中国で行われている療法を取り入れた整体術です。"]), " ", _h('p', ["わが師、岡田實郎先生（中国整体治療研究所所長）は、中国の大学で漢方医学の推拿（すいな）科と骨傷（こつしょう）科で学び、中国の伝統医学を正しく継承する整体師です。当院は、その岡田先生の指導を受けた整体院です。"])])])])]), " ", _h('tr', [_h('td', {
    staticClass: "text-center text-bold"
  }, [_h('label', {
    staticClass: "q-label",
    attrs: {
      "for": "q7"
    }
  }, [_h('span', {
    staticClass: "question"
  }, ["Q."]), "どんなことをするの？\n              "]), " ", _h('input', {
    staticClass: "accordion",
    attrs: {
      "type": "checkbox",
      "name": "accordion",
      "id": "q7"
    }
  }), " ", _h('div', {
    attrs: {
      "id": "q7-answer"
    }
  }, [_h('div', {
    staticClass: "answer"
  }, [_h('img', {
    attrs: {
      "src": "/images/panda-default.gif"
    }
  })]), " ", _h('div', [_h('p', ["初回時に、施術前検査を行います。施術前検査とは、症状記録簿に本人の具体的な症状を記入していただいた後、姿勢、体の歪みを見ます。症状によっては、当院で対応できない場合もあります。"]), " ", _h('p', ["検査の後、症状別に筋肉や靭帯をほぐしていきます。手の指や手のひら、肘を使い、１００％手技により、硬くなった筋肉や靭帯をゆるめていきます。その上で、骨格矯正により、本来の正しい姿勢に戻していきます。"]), " ", _h('p', ["骨格矯正も、まずは関節の可動域を広げることが大切だと考えます。筋肉、靭帯を伸縮させるストレッチも取り入れながら、関節を動かして体の歪みを整えていきます。"]), " ", _h('p', ["また、「中国整体術」の最大の特徴である経絡経穴（ツボ）を刺激することにより、各種の得意な症状を改善することができます。"])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9997d01c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/FAQ.vue
// module id = 435
// module chunks = 0